module.exports = __webpack_public_path__ + "fonts/lato-hairline-webfont.03dc27cf.woff2";